import { memo } from "react";
import { useTranslation } from "react-i18next";

import style from "./BankStatementUploadDescription.module.css";

export const BankStatementUploadDescription = memo(
  ({ testId }: { testId?: string }) => {
    const { t } = useTranslation();

    return (
      <div
        {...(testId ? { "data-testid": `${testId}-description` } : {})}
        className="ps-flex ps-flex-col ps-gap-1 ps-mb-4 ps-mt-4"
      >
        <p className="ps-text-body-v2-sm">
          {t("withdrawals.bank_statement.info_title")}
        </p>
        <ul
          className={`ps-text-body-v2-sm ps-flex ps-flex-col ps-gap-1 ${style["bankstatement-upload-description"]}`}
        >
          <li>{t("withdrawals.bank_statement.info_full_name")}</li>
          <li>{t("withdrawals.bank_statement.info_bank_name")}</li>
          <li>{t("withdrawals.bank_statement.info_account_details")}</li>
          <li>{t("withdrawals.bank_statement.info_issued_date")}</li>
        </ul>
      </div>
    );
  }
);
